import { CSSProperties } from 'react'
import { useLocale } from 'src/lib/hooks/useLocal'
import { RewardsPageType } from 'src/lib/types/uiPreview'
interface PreviewRewardsType {
  uiConfig: RewardsPageType | undefined
}
const PreviewRewards: React.FC<PreviewRewardsType> = ({ uiConfig }) => {
  const { t } = useLocale()
  const earnTileCustomiseUi = uiConfig?.earnTileCustomiseUi
  const earnMessage = uiConfig?.earnMessage
  const creditName = uiConfig?.creditName

  return (
    <div
      className={`flex flex-row rounded-lg p-2 gap-2 outline-1  `}
      style={{
        width: '100%',
        outlineStyle: earnTileCustomiseUi?.outline as CSSProperties['outlineStyle'],
        outlineColor: earnTileCustomiseUi?.outlineColor,
        color: earnTileCustomiseUi?.textColor,
        backgroundColor: earnTileCustomiseUi?.backgroundColor
      }}
    >
      <div
        className='border-right-2 border-r-2 pr-2 content-center '
        style={{
          borderColor: earnTileCustomiseUi?.textColor,
          display: earnTileCustomiseUi?.isCreditNameVisible
        }}
      >
        <p className='uppercase text-xs w-[min-content] max-w-[72px]	'>{creditName}</p>
      </div>
      <div className='flex flex-col '>
        <p className='text-xs  font-normal truncate'>
          {earnMessage?.line_1?.length
            ? earnMessage?.line_1.replace('<Rewards_value>', '21')
            : t('earn_message_line_1').replace('<Rewards_value>', '21')}
        </p>
        <p className='text-sm  font-medium truncate'>
          {earnMessage?.line_2?.length
            ? earnMessage?.line_2.replace('<Rupees_value>', '₹150')
            : t('earn_message_line_2').replace('<Rupees_value>', '₹150')}
        </p>
      </div>
    </div>
  )
}

export default PreviewRewards
